module.exports = __webpack_public_path__ + "static/media/semiTractorNoTrailer_navy.0399ac08.svg";